<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('bill.create_rateset') }}</div>
    <div slot="body">
      <a-alert class="mb-2" :message="$t('bill.rateset_create_tip')" />
      <a-form-model
        ref="form"
        v-bind="formItemLayout"
        :model="form"
        :rules="rules">
        <a-form-model-item :label="$t('bill.parent_rateset')" prop="parent_id">
          <base-select
            v-model="form.parent_id"
            resource="ratesets"
            is-default-select
            :params="ratesetParams"
            :select-props="{placeholder: $t('bill.parent_rateset')}" />
        </a-form-model-item>
        <a-form-model-item :label="$t('table.title.name')" prop="name">
          <a-input v-model="form.name" :placeholder="$t('common.tips.input', [$t('table.title.name')])" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'BillRateSetCreateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        name: '',
      },
      rules: {
        parent_id: { required: true, message: this.$t('common.tips.select', [this.$t('bill.parent_rateset')]) },
        name: { required: true, validator: this.$validate('resourceName') },
      },
      ratesetParams: {
        limit: 20,
        scope: this.$store.getters.scope,
      },
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  created () {
  },
  methods: {
    async doCreate () {
      return this.params.onManager('create', {
        managerArgs: {
          data: this.form,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        await validateModelForm(this.$refs.form)
        this.loading = true
        await this.doCreate()
        this.loading = false
        // this.params.refresh()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
